module.exports = __webpack_public_path__ + "img/pcba_13@2x.f3f09b43.png";